import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./Components/App";
import * as serviceWorker from "./serviceWorker";

import { storyblokInit, apiPlugin } from "@storyblok/react";

storyblokInit({
    accessToken: "sTO5zBZz3QBovHIeO7jTfwtt",
    use: [apiPlugin],
    apiOptions: {
        region: "eu",
    },
    components: {}
});


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
